import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Typography } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './manageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import TableCustom from '../../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { icons } from '../../../../assets/icons/icons'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import { media_type_data } from '../../enum/elibrary_enum'

type Props = {}

const ManageLibraryType: React.FC<Props> = ({ }: Props) => {
    const {
        pathname,
        data,
        end_date,
        handleChangeDateRange,
        handleRequestSort,
        headCells,
        page,
        pageLimit,
        renderData,
        setPage,
        setPageLimit,
        set_search,
        sortBy,
        sortType,
        start_date,
        totalItems,
        media_type,
        handleCloseModal,
        showModal,
        set_showModal,
        handleCheckedMediaType,
        handleSubmit,
        category_library,
        set_category_library,
        setFormState,
        formState
    } = useManageState();
    return (
        <ContainerLayout
            title='จัดการหมวดหมู่'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "A",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "จัดการข้อมูล E-Library",
                            disabled_match: true
                        },
                        {
                            key: "B",
                            name: "จัดการหมวดหมู่",
                            pathName: pathname
                        },
                    ]}
                />
            }
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    startAdornment: <Box sx={{ mr: 1 }}><icons.SearchNormal /></Box>,
                                    placeholder: "ค้นหา ชื่อ",
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search })
                                }
                            },
                            {
                                seq: 2,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3,
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.name || "",
                                    labelId: "A",
                                    onChange: (_, val) => set_category_library(val?.value ?? ""),
                                    placeholder: "ทุกประเภทสื่อ",
                                    options: media_type_data,
                                    value: media_type_data?.find((x) => x?.value === category_library) || null
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3,
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: "ช่วงวันที่",
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            maxWidth: 'fix-content',
                                            buttonProps: {
                                                onClick: () => set_showModal("ADD")
                                            },
                                            key: "เพิ่มหมวดหมู่",
                                            label: "เพิ่มหมวดหมู่",
                                            type: "ADD"
                                        }
                                    ],
                                }
                            }
                        ]}
                    />



                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>


                    {showModal !== "" && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={handleSubmit}
                            open
                            enable_up_transition
                            title='เพิ่มหมวดหมู่'
                            subTitle='กรุณาระบุรายละเอียด'
                            hintSubmitButton={showModal === 'VIEW'}
                            disabledSubmitButton={!formState.library_type_name || media_type?.every((x) => !x?.checked)}
                            scrollBody
                            form={
                                <Box className="w-full py-4">
                                    <StateComponents
                                        disabledAllField={showModal === 'VIEW'}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                type: "TEXT_FIELD",
                                                fieldProps: {
                                                    heading: "ชื่อหมวดหมู่",
                                                    value: formState.library_type_name,
                                                    onChange: (e) => setFormState((prev) => ({ ...prev, library_type_name: e.target.value })),
                                                    placeholder: "ระบุชื่อหมวดหมู่",
                                                    required: true
                                                }
                                            },
                                        ]}
                                    />
                                    <Box my={1} className="flex gap-1 justify-start items-center">
                                        <Typography >
                                            ประเภทสื่อ
                                        </Typography>
                                        <Typography sx={{ color: 'red' }}>*</Typography>
                                    </Box>
                                    <Box className="flex flex-col gap-2">
                                        {media_type?.map((list, i) => {
                                            return (
                                                <CheckBoxCustom
                                                    disabled={showModal === 'VIEW'}
                                                    checked={list.checked}
                                                    label={list.name}
                                                    setChecked={() => handleCheckedMediaType(i)}
                                                />
                                            )
                                        })}
                                    </Box>
                                </Box>
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default ManageLibraryType